import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  right: 27px;\n  top: 40%;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        border-color: ", ";\n        box-shadow: none;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        background: none;\n        opacity: 1;\n      }\n\n      ", " {\n        color: ", ";\n      }\n\n      ", " {\n        box-shadow: ", ";\n        border: ", ";\n        border-bottom: ", ";\n\n        &:focus {\n          ", ";\n          border-bottom: ", ";\n\n          + ", " {\n            color: ", ";\n          }\n        }\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  vertical-align: top;\n  width: 100%;\n\n  ", " {\n    order: 1;\n  }\n\n  ", " {\n    background: ", ";\n    border-radius: 1px;\n    padding: ", ";\n    padding-right: 0;\n    border: ", ";\n    border-bottom: ", ";\n    box-shadow: ", ";\n    order: 2;\n\n    &:focus {\n      border: ", ";\n      border-bottom: ", ";\n      box-shadow: ", ";\n    }\n\n    &[disabled] {\n      background-color: rgba(37, 34, 40, 0.05);\n      box-shadow: inset 0 0 5px 0 rgba(0, 0, 0, 0.08);\n      border-color: ", ";\n    }\n  }\n\n  ", " {\n    order: 3;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  min-height: ", "px;\n  line-height: 1.5;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  border: none;\n  box-sizing: border-box;\n  display: block;\n  outline: none;\n  width: 100%;\n  margin: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  line-height: 1.78;\n\n  ::placeholder {\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n  }\n\n  &[disabled] {\n    cursor: not-allowed;\n    color: ", ";\n\n    + ", " {\n      color: ", ";\n    }\n\n    ::placeholder {\n      color: ", ";\n    }\n  }\n\n  &:focus {\n    caret-color: ", ";\n\n    + ", " {\n      color: ", ";\n    }\n\n    ::placeholder {\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  color: ", ";\n  line-height: 1.5;\n  letter-spacing: normal;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from "styled-components";
import { colors, typography, size } from "../../shared/constants";
export var Label = styled.label(_templateObject(), typography.weight.bold, typography.type.nexa, size.md, colors.gray4);
export var Input = styled.input.attrs(function (o) {
  return {
    type: o.type ? o.type : "text"
  };
})(_templateObject2(), colors.gray4, typography.type.nexa, colors.gray3, typography.type.nexa, typography.weight.book, colors.gray3, Label, colors.gray3, colors.gray3, colors.teal4, Label, colors.teal6);
export var Error = styled.div(_templateObject3(), colors.red3, size.md, typography.type.nexa, size.lg);
export var InputWrapper = styled.div.attrs(function (o) {
  return {
    footerStyle: o.footerStyle
  };
})(_templateObject4(), Label, Input, colors.white, function (o) {
  return o.footerStyle ? size.sm + "px 0" : "".concat(size.xs1, "px ").concat(size.md, "px");
}, function (o) {
  return o.footerStyle ? "none" : "1px solid " + colors.green2;
}, function (o) {
  return o.footerStyle ? "2px solid " + colors.green5 : "";
}, function (o) {
  return o.footerStyle ? "none" : "4px 4px 15px -5px rgba(0, 0, 0, 0.1)";
}, function (o) {
  return o.footerStyle ? "none" : "1px solid " + colors.gray2;
}, function (o) {
  return o.footerStyle ? "2px solid " + colors.green5 : "1px solid " + colors.teal5;
}, function (o) {
  return o.footerStyle ? "none" : colors.teal5 + " 0 0 0 1px inset";
}, colors.gray2, Error, function (o) {
  return o.error && css(_templateObject5(), Error, Label, colors.red3, Input, o.footerStyle ? "none" : colors.red3 + " 0 0 0 1px inset", o.footerStyle ? "none" : "1px solid " + colors.gray2, o.footerStyle ? "2px solid " + colors.red3 : "1px solid " + colors.red3, o.footerStyle ? "none" : colors.red3 + " 0 0 0 1px inset", o.footerStyle ? "2px solid " + colors.red3 : "1px solid " + colors.red3, Label, colors.red3);
}, function (o) {
  return o.validated && css(_templateObject6(), Input, colors.green2);
});
export var CheckWrapper = styled.div(_templateObject7());